export var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
export var SET_CONTENT_LENGTH_HEADER = 'contentLengthMiddleware';
export var localTestingStorageEndpoint = 'http://localhost:20005';
export var UPLOADS_STORAGE_KEY = '__uploadInProgress';
//# sourceMappingURL=StorageConstants.js.map